import React from "react";
import PropTypes from "prop-types";
import { Row, Table, Container } from "react-bootstrap";
import DataTablePagination from "./DataTablePagination";
import TableModifiers from "./TableModifiers";
import ExportButton from "./ExportButton";

export default class DataGrid extends React.Component {
  render() {
    let columnHeaders = this.props.isAdmin ? this.props.adminHeaders.concat(this.props.headers) : this.props.headers;
    let firstIndexDisplayed = this.props.disablePagination ? 0 : this.state.displayedScreen * this.state.numberPerScreen;
    let lastIndexDisplayed = this.props.disablePagination ? this.props.data.length : firstIndexDisplayed + this.state.numberPerScreen;
    const exportButton = (
      <ExportButton
        data={this.props.data}
        headers={columnHeaders || []}
        page={this.props.exportName || "revShareAppExport"}
        pageModifier={this.props.isAdmin ? "admin" : ""}
      />
    );

    const modifierColumns = this.props.hideExport
      ? (this.props.tableModifiers || [])
      : (this.props.tableModifiers ? [exportButton, ...this.props.tableModifiers] : [exportButton]);

    return (
      <Container className="data-grid" fluid>
        {modifierColumns.length > 0 && (
          <TableModifiers columns={modifierColumns} />
        )}
        {!this.props.disablePagination && (
          <DataTablePagination
            displayedScreen={this.state.displayedScreen}
            numberOfScreens={this.numberOfScreens()}
            numberPerScreen={this.state.numberPerScreen}
            numberPerScreenOptions={this.numberPerScreenOptions}
            setDisplayedScreen={this.setDisplayedScreen}
            setNumberPerScreen={this.setNumberPerScreen}
          />
        )}
        <Row>
          <Table hover responsive>
            <thead>
              <tr>
                {columnHeaders.map((header) => (
                  <th key={header.key} style={header.headerStyle || {}}>{header.label}</th>
                ))}
                {this.props.actionButtons ? <th style={{ textAlign: "center" }}>Actions</th> : null}
              </tr>
            </thead>
            <tbody>
              {this.props.data.slice(firstIndexDisplayed, lastIndexDisplayed).map((row, index) => (
                <tr key={"tableRow" + index}>
                  {columnHeaders.map((header) => (
                    <td key={header.key + index} style={header.style || {}}>{row[header.key]}</td>
                  ))}
                  {this.props.actionButtons ? (
                    <td key={"row" + index + "_actions"} style={{ textAlign: "center" }}>{this.props.actionButtons(row)}</td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </Table>
        </Row>
      </Container>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      numberPerScreen: this.numberPerScreenOptions[0].num,
      displayedScreen: 0,
    };

    this.numberOfScreens = this.numberOfScreens.bind(this);
    this.setDisplayedScreen = this.setDisplayedScreen.bind(this);
    this.setNumberPerScreen = this.setNumberPerScreen.bind(this);
  }

  numberOfScreens() {
    return Math.ceil(this.props.data.length / this.state.numberPerScreen);
  }

  setDisplayedScreen(screenNumber) {
    this.setState({
      displayedScreen: screenNumber,
    });
  }

  setNumberPerScreen(perScreen) {
    let numberPerScreen = perScreen === -1 ? this.props.data.length : perScreen;
    this.setState({
      numberPerScreen: numberPerScreen,
    });
    let numberOfScreens = Math.ceil(this.props.data.length / numberPerScreen);
    if (this.state.displayedScreen > numberOfScreens) {
      this.setDisplayedScreen(numberOfScreens - 1);
    }
  }

  maxDisplayedScreenOptions = 10;

  numberPerScreenOptions = [
    { num: 10, display: "10" },
    { num: 20, display: "20" },
    { num: 50, display: "50" },
    { num: -1, display: "All" },
  ];
}

DataGrid.propTypes = {
  actionButtons: PropTypes.func,
  adminHeaders: PropTypes.array,
  data: PropTypes.array.isRequired,
  disablePagination: PropTypes.bool,
  exportName: PropTypes.string,
  hideExport: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isGhosting: PropTypes.bool,
  headers: PropTypes.array.isRequired,
  tableModifiers: PropTypes.array,
};
